module.exports = __webpack_public_path__ + "static/media/expressive_figure_painting.505df5e0.png";